import { green, red, orange, yellow, blue, amber, brown, cyan, deepOrange } from '@mui/material/colors';

export const LIST_COLORS = [green[500], red[500], orange[500], yellow[500], blue[500], amber[500], brown[500], cyan[500], cyan[500], deepOrange[500]]
export const ageGroups = [[0, 10], [11, 20], [21, 30], [31, 40], [41, 50], [51, 60], [61, 70], [71, 80], [81, 1000]];
export const COUNT_AGE = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];